import { Input, Select, SelectItem } from "@heroui/react";
import { FilterCard } from "@/components/data-table";

const FilterData = ({ table, initialFilters, filterOptions = {} }) => {
    const { masterCashes = [] } = filterOptions;
    const { pending, setPending, isOpen, apply, clear } = table.filterPanel;

    const handleClear = () => {
        setPending(initialFilters);
        clear();
    };

    return (
        <FilterCard isVisible={isOpen} onClear={handleClear} onApply={apply}>
            <Input
                label="Pencarian"
                placeholder="Cari..."
                variant="flat"
                value={pending.search || ""}
                onValueChange={(val) =>
                    setPending((prev) => ({
                        ...prev,
                        search: val,
                    }))
                }
                isClearable
                onClear={() =>
                    setPending((prev) => ({
                        ...prev,
                        search: "",
                    }))
                }
            />

            <Input
                type="date"
                label="Tanggal Mulai"
                variant="flat"
                value={pending.start_date || ""}
                onValueChange={(val) =>
                    setPending((prev) => ({
                        ...prev,
                        start_date: val,
                    }))
                }
            />

            <Input
                type="date"
                label="Tanggal Akhir"
                variant="flat"
                value={pending.end_date || ""}
                onValueChange={(val) =>
                    setPending((prev) => ({
                        ...prev,
                        end_date: val,
                    }))
                }
            />

            <Select
                label="Kas Asal"
                placeholder="Pilih Kas Asal"
                variant="flat"
                selectedKeys={
                    pending.source_master_cash_id
                        ? [String(pending.source_master_cash_id)]
                        : []
                }
                onSelectionChange={(keys) =>
                    setPending((prev) => ({
                        ...prev,
                        source_master_cash_id: Array.from(keys)[0],
                    }))
                }
            >
                {masterCashes.map((item) => (
                    <SelectItem key={item.value}>{item.title}</SelectItem>
                ))}
            </Select>

            <Select
                label="Kas Tujuan"
                placeholder="Pilih Kas Tujuan"
                variant="flat"
                selectedKeys={
                    pending.destination_master_cash_id
                        ? [String(pending.destination_master_cash_id)]
                        : []
                }
                onSelectionChange={(keys) =>
                    setPending((prev) => ({
                        ...prev,
                        destination_master_cash_id: Array.from(keys)[0],
                    }))
                }
            >
                {masterCashes.map((item) => (
                    <SelectItem key={item.value}>{item.title}</SelectItem>
                ))}
            </Select>
        </FilterCard>
    );
};

export default FilterData;
